import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCrop';
/** Renders an SVG icon. */
const SvgCrop = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8 2a1 1 0 0 1 1 1v20h20a1 1 0 1 1 0 2h-4v4a1 1 0 1 1-2 0v-4H9a2 2 0 0 1-2-2V9H3a1 1 0 0 1 0-2h4V3a1 1 0 0 1 1-1m4 6a1 1 0 0 1 1-1h10a2 2 0 0 1 2 2v10a1 1 0 1 1-2 0V9H13a1 1 0 0 1-1-1"
        clipRule="evenodd"
      />
    </svg>
  );
};
SvgCrop.displayName = displayName;
export default SvgCrop;
